import React from 'react';
import ReactDOM from 'react-dom';
import PanoramaView from './components/PanoramaView';

import './assets/scss/main.scss';

if (process.env.NODE_ENV === 'development') {
  require('./assets/scss/_fonts.scss');
}

export function create(initConfig: any = {}) {
  ReactDOM.render(
    <PanoramaView
      img={initConfig.panoramaUrl}
      width={initConfig.width}
      height={initConfig.height}
      title={initConfig.title}
      vehicleId={initConfig.vehicleId}
    />,
    document.getElementById(initConfig.selectorId)
  );
}
